import React, { useState } from 'react';
import AuthOptions from './AuthOptions'; // Import the AuthOptions component
import Tabs from './Tabs'; // Import the Tabs component
import ModalStructure from './ModalStructure'; // Import the ModalStructure component

const LoginModal = ({ isVisible, onClose, initialTab = 'user', hidePersonalAccount = false, hideBusinessAccount = false }) => {
  const [activeTab, setActiveTab] = useState(initialTab); // Set the active tab based on initialTab
  const [isOtpSent, setIsOtpSent] = useState(false); // OTP state

  // Function to handle redirect to backend OAuth endpoint for Google login
  const handleGoogleLogin = () => {
    window.location.href = process.env.REACT_APP_GOOGLE_OAUTH_LOGIN;
  };

  // Function to handle email login
  const handleEmailLogin = () => {
    console.log('Email sign in for:', activeTab);
    setIsOtpSent(true); // OTP state set to true
  };

  // Handle modal close and reset OTP state
  const handleClose = () => {
    setIsOtpSent(false); // Reset OTP state when modal is closed
    onClose(); // Call the onClose prop to handle visibility
  };

  if (!isVisible) return null;

  return (
    <ModalStructure onClose={handleClose}>
      {/* Only show the Tabs component if OTP is not yet sent */}
      {!isOtpSent && (
        <Tabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          hidePersonalAccount={hidePersonalAccount}
          hideBusinessAccount={hideBusinessAccount}
        />
      )}

      {/* Authentication options for the selected tab */}
      <div className="h-full flex flex-col justify-top">
        <AuthOptions
          activeTab={activeTab}
          handleGoogleLogin={handleGoogleLogin}
          handleEmailLogin={handleEmailLogin}
          onClose={handleClose}
          isOtpSent={isOtpSent}
        />
      </div>
    </ModalStructure>
  );
};

export default LoginModal;
